module.exports = __webpack_public_path__ + "d17f1abba4ccea406c3f1ce93ea43cb1.png";